module.exports = __webpack_public_path__ + "media/images/new_home/exit_black-7f9b49a43b59cc0f2809f4141e750c78.png";